<template>
  <div>
    <form @submit.prevent="submit()">

      <!-- <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'acl_submodulo_id'"
            :listaDeOptions="listaDeSubModulos"
            v-model="formulario.acl_submodulo_id"
            :optionLabel="'submodulo'"
            :placeholder="'SubMódulo'"
            :error="validationErrors.first('acl_submodulo_id')"
            data-vv-as="SubMódulo"
            v-validate="'required'"
          />
      </div> -->
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'perfil'"
            v-model="formulario.name" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|min:4'"
            :error="validationErrors.first('perfil')"
         />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent
            name="descricao"
            type="textarea"
            rows="3"
            placeholder="Descrição"
            data-vv-as="Descrição"
            :error="validationErrors.first('descricao')"
            v-model="formulario.description"
        />
      </div>      
      
      <div class="container-botoes">
        <!-- Snippet start -->
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <!-- Snippet end -->
        <!-- Snippet start -->
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
        <!-- Snippet end -->
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioPerfilComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    perfil: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.perfil || {
        name: '',
        description: '',
        acl_submodulo_id: ''
      }
    }
  },

  computed: {
    ...mapGetters('submodulos', ['listaDeSubModulos'])
  },
  methods: {
    ...mapActions('perfis', [
      'salvarPerfil',
      'atualizarPerfil',
    ]),
    ...mapActions('submodulos', [
      'listarSubModulos'
    ]),
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {

            const resp = await this.salvarPerfil(this.formulario);     

            if(!resp){
               return;
            }   

            this.fecharModal();

            return;
          }

          const resp = await this.atualizarPerfil(this.formulario);

          if(!resp) {
            return;
          }

          this.fecharModal();
        }
      });      
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },
  
  // beforeMount(){
  //   this.listarSubModulos();
  // }


}
</script>